import Card from 'components/card/Card'
import Button from 'components/button/Button'
import SawitPoinTable from './components/SawitPoinTable'
import { useLocation, useNavigate } from 'react-router-dom'
import useSawitPoin from './hooks/useSawitPoin'
import { useContext, useEffect } from 'react'
import Errors from 'components/errors/Errors'
import { UserContext } from 'context/UserContext'
import { UserRoleEnum } from 'generated/api'

export default function SawitPoinList() {
  const navigate = useNavigate()
  const location = useLocation()
  const [state] = useContext(UserContext)
  const isFinanceLead = state.userInfo?.role === UserRoleEnum.FinanceLead
  const { fetchSawitPoinList, listSawitPoin, loadingFetch, failedFetch, toastContainer, toast } =
    useSawitPoin()

  useEffect(() => {
    fetchSawitPoinList()
  }, [])

  useEffect(() => {
    // if already success to request sawitpoin
    if (location?.state?.requestToast == 'success') {
      toast('Permintaan berhasil diajukan ke finance', 'success')
    } else if (location?.state?.approveToast == 'success') {
      // if already success to approve sawitpoin
      toast('Konfirmasi permintaan berhasil terkirim', 'success')
    } else if (location?.state?.approveToast == 'failed') {
      // if already failed to approve sawitpoin
      toast('Konfirmasi gagal diajukan', 'danger')
    }
  }, [location?.state?.toast])

  return (
    <div className="content-wrapper">
      {toastContainer}
      <Card
        loading={loadingFetch}
        dataTestId="card_sawitpoin"
        spinnerTestId="loader_sawitpoin"
        className="rounded-xl p-0 pb-2"
      >
        {!isFinanceLead && (
          <Card.Header className="pt-4 px-4 flex justify-end">
            <Button
              type="submit"
              loading={loadingFetch}
              block
              onClick={() => navigate('/sawitpoin/request')}
              data-testid="btn_request"
              className="pt-4 rounded-xl w-fit pb-4 font-bold text-sm"
              label="Buat Permintaan"
              variant="solid-primary"
            />
          </Card.Header>
        )}
        {listSawitPoin.length > 0 && !failedFetch && (
          <Card.Body className="m-0">
            <SawitPoinTable data={listSawitPoin} isLoading={loadingFetch} />
          </Card.Body>
        )}
        {failedFetch && (
          <Errors
            dataTestId="fetch_point"
            inverse={false}
            header="Mohon maaf, permintaan Anda tidak dapat diproses."
            paragraph="terjadi kesalahan internal pada server kami. Silakan coba beberapa saat lagi."
            button={true}
            buttonLabel="Coba lagi"
            buttonAction={fetchSawitPoinList}
          />
        )}
      </Card>
    </div>
  )
}
